import { BranchResponseDto } from "../shared/dtos/branch/BranchResponseDto";
import { BranchSummaryDto } from "../shared/dtos/branch/BranchSummaryDto";

export class BranchMapper {
  public static mapBranchToSummary(
    detailedBranch: BranchResponseDto,
  ): BranchSummaryDto {
    return {
      id: detailedBranch.id,
      name: detailedBranch.name,
      branchCode: detailedBranch.branchCode,
      schoolName: detailedBranch.schoolName,
      branchStatus: detailedBranch.branchStatus,
      principalName: detailedBranch.principalName,
      contactPhone: detailedBranch.contactPhone,
      contactEmail: detailedBranch.contactEmail,
      createdAt: detailedBranch.createdAt,
      updatedAt: detailedBranch.updatedAt,
    };
  }
}
